import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Modal } from 'antd';
import ExchangeForm from '@organisms/exchange/form/Exchange';

import { tConsume } from 'TRANSLATION';
import defaults from 'DEFAULTS';

class NewExchange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    const { forceOpen } = this.props;
    if (forceOpen) {
      this.setState({ visible: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.forceOpen !== this.props.forceOpen) {
      this.setState({ visible: this.props.forceOpen });
    }
  }

  toggleModal = (visible = !this.state.visible) => {
    this.setState({ visible });

    if (this.props.onModalClose && !visible) {
      this.props.onModalClose();
    } else {
      this.setState({ visible: visible });
    }
  };

  render() {
    const { visible } = this.state;
    const { t, userType, getData, vendor, data, forceOpen } = this.props;

    return (
      <>
        {!forceOpen && (
          <Button
            type={'primary'}
            icon={'plus'}
            onClick={() => this.toggleModal(true)}
            size={defaults.antd.button.size}
            block
          >
            {t('button.createExchange')}
          </Button>
        )}

        <Modal
          visible={visible}
          destroyOnClose={true}
          maskClosable={false}
          title={t('page.modalTitle.title')}
          footer={null}
          onCancel={() => this.toggleModal()}
        >
          <ExchangeForm
            userType={userType}
            getData={getData}
            toggleModal={this.toggleModal}
            vendor={vendor}
            data={data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = ({ personal }) => ({
  personalData: personal.data,
});

export default tConsume(connect(mapStateToProps)(NewExchange));

NewExchange.propTypes = {
  userType: PropTypes.string.isRequired,
  getData: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  vendor: PropTypes.string,
  data: PropTypes.object,
  forceOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
};

NewExchange.defaultProps = {
  forceOpen: false,
};
